import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Col, Divider, Form, Input, Modal, Row } from "antd";
import dayjs, { Dayjs } from "dayjs";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import FormattedAddress from "../../../components/FormattedAddress";
import ConsignmentFreightTable from "../ConsignmentFreightTable";
import SenderReceiverSelect from "../../../components/SenderReceiverSelect";
import DateRangePicker from "../../../components/DateRangePicker";
import { useAppSelector } from "../../../../../store";
import { selectedTenantSettingsSelector } from "../../../../../store/slice/auth";
const TemplateToConsignmentModal = (props) => {
    const [form] = Form.useForm();
    const [stateLoading, setStateLoading] = useState(false);
    const [stateOverriddenReceiver, setStateOverriddenReceiver] = useState(null);
    const selectedTenantSettings = useAppSelector(selectedTenantSettingsSelector);
    useEffect(() => {
        form.setFieldsValue({
            deliveryInstructions: props.consignmentTemplate?.instructions
        });
    }, [props.consignmentTemplate]);
    const createConsignment = (deliveryFrom, deliveryTo, salesOrderRef, customerRef, instructions, qtyOverrides, receiverIdOverride) => {
        const request = {
            deliveryFrom: deliveryFrom.toISOString(),
            deliveryTo: deliveryTo.toISOString(),
            instructions: instructions,
            salesOrderRef: salesOrderRef,
            customerRef: customerRef,
            qtyOverrides: qtyOverrides,
            receiverIdOverride: receiverIdOverride
        };
        setStateLoading(true);
        axios.post(`/admin/v1/consignment-templates/${props.consignmentTemplate.id}/instantiate`, request)
            .then(response => {
            props.onCreated(response.data);
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setStateLoading(false);
        });
    };
    const onModalOk = () => {
        form.submit();
    };
    const onFinish = (formValues) => {
        const mapQtyOverrides = {}; // new Map<number, number>();
        if (formValues.qtyOverrides) {
            // We are relying on JS arrays to be sparse, index is the template_freight ID, value is overridden qty
            formValues.qtyOverrides.forEach((qty, index) => {
                mapQtyOverrides[index] = qty;
            });
        }
        createConsignment(formValues.deliveryDateTimeRange[0], formValues.deliveryDateTimeRange[1], formValues.salesOrderRef, formValues.customerRef, formValues.deliveryInstructions, mapQtyOverrides, formValues.receiverIdOverride);
    };
    const onSenderReceiverSelected = (senderReceiver) => {
        setStateOverriddenReceiver(senderReceiver);
    };
    const template = props.consignmentTemplate;
    const sender = template?.sender;
    const receiver = template?.receiver;
    const customer = template?.customer;
    const dayAndTimeFromNow = (strTime, days) => {
        const daysToAdd = days || 0;
        return dayjs(strTime, 'HH:mm').add(daysToAdd, 'days');
    };
    const defaultDeliveryWindow = (template?.defaultDeliveryWindowFromTime && template.defaultDeliveryWindowToTime)
        ? [
            dayAndTimeFromNow(template.defaultDeliveryWindowFromTime, template.defaultDeliveryWindowInDays),
            dayAndTimeFromNow(template.defaultDeliveryWindowToTime, template.defaultDeliveryWindowInDays)
        ] : null;
    return (_jsx(Modal, { title: "Create Delivery", open: props.open, confirmLoading: stateLoading, onCancel: props.onCancel, destroyOnHidden: true, onOk: onModalOk, okText: "Create Delivery", width: 650, children: _jsxs(Form, { layout: "vertical", onFinish: onFinish, form: form, children: [customer &&
                    _jsx(Row, { children: _jsx(Col, { sm: 24, children: _jsxs("div", { children: [_jsx("h3", { className: "text-center", children: customer.name }), _jsx(Divider, {})] }) }) }), _jsxs(Row, { children: [_jsx(Col, { sm: 12, children: sender &&
                                _jsxs("div", { children: [_jsx("h4", { children: "Pickup" }), _jsx(FormattedAddress, { companyName: sender.companyName, address: sender.address })] }) }), _jsx(Col, { sm: 12, children: _jsxs("div", { children: [_jsx("h4", { children: "Delivery" }), stateOverriddenReceiver && stateOverriddenReceiver.address
                                        ? _jsx(FormattedAddress, { companyName: stateOverriddenReceiver.companyName, address: stateOverriddenReceiver.address })
                                        : (receiver) &&
                                            _jsx(FormattedAddress, { companyName: receiver.companyName, address: receiver.address })] }) })] }), _jsx(Row, { children: _jsx(Col, { sm: 24, children: _jsx(ConsignmentFreightTable, { tableSize: "small", freight: props.consignmentTemplate?.freight ?? [], hasActions: false, netQtyEditable: true }) }) }), _jsx(Row, { children: _jsxs(Col, { sm: 24, children: [_jsx(Form.Item, { name: "receiverIdOverride", className: "margin-top", label: "Delivery Address", initialValue: receiver && receiver.id, valuePropName: "senderReceiverId", rules: [{
                                        required: true,
                                        message: 'Please select a delivery address.'
                                    }], children: _jsx(SenderReceiverSelect, { tenantId: props.consignmentTemplate && props.consignmentTemplate.tenant?.id, onSenderReceiverSelected: onSenderReceiverSelected }) }), _jsx(Form.Item, { name: "deliveryDateTimeRange", label: "Delivery Date/Time", initialValue: defaultDeliveryWindow, rules: [{
                                        required: true,
                                        message: 'Please select a delivery window.'
                                    }], children: _jsx(DateRangePicker, { allowClear: true }) }), _jsx(Form.Item, { name: "salesOrderRef", label: "Sales Order Reference", rules: [{
                                        max: 20, message: 'Please limit to 20 characters.'
                                    }], children: _jsx(Input, { maxLength: 20 }) }), _jsx(Form.Item, { name: "customerRef", label: "Customer Reference", rules: [{
                                        required: selectedTenantSettings?.consignmentCustomerRefMandatory,
                                        message: 'Please enter the customer reference'
                                    }, {
                                        max: 30,
                                        message: 'Please limit to 30 characters.'
                                    }], children: _jsx(Input, { maxLength: 30 }) }), _jsx(Form.Item, { name: "deliveryInstructions", label: "Delivery Instructions", initialValue: props.consignmentTemplate?.instructions, children: _jsx(Input.TextArea, { autoSize: { minRows: 3, maxRows: 6 } }) })] }) })] }) }));
};
export default TemplateToConsignmentModal;
